module.exports = __webpack_public_path__ + "img/02_sub_uk.5194ae6a.svg";